export const fetchRequest = ({
    method = "GET",
    endpoint,
    body,
    headers = {},
    options = {},
    contentType = "application/json",
    token
}: {
    method?: "GET" | "POST" | "PUT" | "DELETE";
    endpoint: string;
    body?: BodyInit;
    headers?: HeadersInit;
    options?: RequestInit;
    contentType?: string;
    token?: string;
}) => {
    const requestOptions = {
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        referrerPolicy: "no-referrer",
        headers: {
            "Content-Type": contentType,
            ...headers,
            ...(token && { Authorization: token })
        },
        method,
        ...options,
        ...(body && { body })
    } as RequestInit;

    return fetch(endpoint, requestOptions);
};
